import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { HydrogenAppConfigService } from '../host.config.service';

@Injectable()
export class XiOApplicationInsightService {

    private config: Microsoft.ApplicationInsights.IConfig;

    constructor(configSvc: HydrogenAppConfigService) {
        console.log(AppInsights);
        this.config = {
            instrumentationKey: configSvc.config.appInsights.instrumentationKey,
            overridePageViewDuration: true
        }; 
        if (!AppInsights.config) {
            AppInsights.downloadAndSetup(this.config);
        } 
    }

    logPageView(name?: string, url?: string, properties?: any,
        measurements?: any, duration?: number) {
        // ensure we have valid values for the required fields
        if (typeof name !== "string") {
            name = window.document && window.document.title || "";
        }

        if (typeof url !== "string") {
            url = window.location && window.location.href || "";
        }


        AppInsights.trackPageView(name, url, properties, measurements, duration);
    }

    logEvent(name: string, properties?: any, measurements?: any) {
        AppInsights.trackEvent(name, properties, measurements);
    }

    logMetric(name: string, value: number) {
        AppInsights.trackMetric(name, value);
    }
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/xioapplicationinsight.service.ts